import React, { useEffect, useState } from 'react';
import './settings.scss';
import classNames from 'classnames';
import { useDispatch, useSelector } from 'react-redux';
import { useIntl } from 'react-intl';
import ViolationExportColumn from './ViolationExportColumn';
import DetectionExportColumn from './DetectionExportColumn';
import { getSystemData } from '../../System/reducer';
import { getSettingsData } from '../reducer';
import { loadExport, loadViolationList } from '../actions';
import { responseLogWithNotification, useUpdatePeriod } from '../../../utils/utils';
import Loader from '../../../components/base/Loader/Loader';

export default function ExportSettingsColumns() {
  const [selectedCategory, setSelectedCategory] = useState(null);
  const dispatch = useDispatch();
  const { updatePeriod } = useSelector(getSystemData);
  const {
    loadingExportList,
    loadingSaveExport,
    loadingUpdateExport,
  } = useSelector(getSettingsData);
  const intl = useIntl();
  const { formatMessage } = intl;
  const loadData = () => {
    const p1 = dispatch(loadExport()).catch(responseLogWithNotification);
    const p2 = dispatch(loadViolationList()).catch(responseLogWithNotification);
    return Promise.all([p1, p2]);
  };
  const [setPeriod] = useUpdatePeriod(loadData, updatePeriod);
  useEffect(() => setPeriod(updatePeriod), [updatePeriod]);

  const categoryList = [
    { value: 1, label: formatMessage({ id: 'export.violation' }), component: ViolationExportColumn },
    { value: 2, label: formatMessage({ id: 'export.detection' }), component: DetectionExportColumn },
  ];

  const selectedItem = categoryList.find(item => item.value === selectedCategory);
  const Component = selectedItem && selectedItem.component ? selectedItem.component : null;
  return (
    <>
      <Loader loading={loadingExportList || loadingSaveExport || loadingUpdateExport} />
      <div className="settings-category frame">
        <div className="settings-header">
          <div className="settings-label">{formatMessage({ id: 'settings.complex.category' })}</div>
          <div className="settings-buttons" />
        </div>
        <div className="settings-list-wrapper">
          <div className="settings-list custom-scroll-theme">
            {categoryList.map((item, key) => (
              <div
                key={key}
                onClick={() => {
                  setSelectedCategory(item.value);
                }}
                className={classNames('settings-menu-item', { selected: selectedCategory === item.value })}
              >{item.label}
              </div>
            ))}
          </div>
        </div>
      </div>
      {Component ? <Component loadData={loadData} /> : <div className="settings-options frame" />}
    </>
  );
}
